import { useMemo } from 'react';
import { getZonedDate } from '@/utils/dayjs';
import { convert12To24 } from '@/utils/deliveryTime';

interface UseNextDeliveryDateTimeParams {
    enabled: boolean;
    frequency: 'WEEKLY' | 'MONTHLY';
    hour: number;
    isAm: boolean;
    timezone: string;
}

export function useNextDeliveryDateTime({ enabled, frequency, hour, isAm, timezone }: UseNextDeliveryDateTimeParams) {
    return useMemo(() => {
        if (!enabled) {
            return null;
        }

        const now = getZonedDate(timezone);
        const deliveryHour = convert12To24(hour, isAm).split(':')[0];
        const deliveryMinute = '00';

        if (frequency === 'WEEKLY') {
            let nextMonday = now.day(1);
            if (nextMonday.isBefore(now) || (nextMonday.isSame(now, 'day') && now.hour() >= Number(deliveryHour))) {
                nextMonday = nextMonday.add(1, 'week');
            }
            return nextMonday.hour(Number(deliveryHour)).minute(Number(deliveryMinute)).second(0);
        } else {
            let nextFirst = now.date(1).hour(Number(deliveryHour)).minute(Number(deliveryMinute)).second(0);
            if (nextFirst.isBefore(now)) {
                nextFirst = nextFirst.add(1, 'month');
            }
            return nextFirst;
        }
    }, [enabled, frequency, hour, isAm, timezone]);
}
